import { AnyAction } from "redux"
import { IProblemListItem } from "../../components/modules/API/TeudotProblems/models/problems"
import { LOAD_PROBLEM_TYPES, CLEAR_PROBLEM_TYPES } from "../actions/actionsTypes"

export interface IProblemTypesState {
  problemTypes: IProblemListItem[] | null
  isLoading: boolean
}

const initialState: IProblemTypesState = {
  problemTypes: null,
  isLoading: false
}

const problemTypesReducer = (state = initialState, action: AnyAction) => {
  switch(action.type) {
    case LOAD_PROBLEM_TYPES:
      return {
        ...state,
        problemTypes: action.payload,
        isLoading: false
      }
    case CLEAR_PROBLEM_TYPES:
      return initialState
    default: 
      return state
  }
}

export default problemTypesReducer 